<template>
  <div
    class="modal-box"
    v-if="currentProject"
  >
    <div class="modal-title">
      <h3>Bewerk project
      </h3>
      <div class="flex-divider"></div>
      <base-button
        type="secondary"
        @click="closeModal"
      >
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label
            for="projectName"
            class="label required"
          >Projectnaam</label>
          <base-input
            type="text"
            id="projectName"
            name="projectName"
            v-model="projectBody.projectName"
            data-vv-as="Projectnaam"
            v-validate="'required'"
          />
          <base-input-warning :error="errors.first('projectName')" />
        </div>
        <div class="input-container">
          <label
            for
            class="label"
          >Beschrijving</label>
          <textarea
            class="input"
            v-model="projectBody.description"
          ></textarea>
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Adres</h4>
        </div>
        <div class="input-row">
          <div class="input-container">
            <label class="label">Straat</label>
            <base-input
              type="text"
              v-model="projectBody.address.street"
            />
          </div>
          <div class="input-container">
            <label class="label">Huisnummer</label>
            <base-input
              type="text"
              v-model="projectBody.address.houseNumber"
            />
          </div>
        </div>
        <div class="input-container">
          <label class="label">Stad</label>
          <base-input
            type="email"
            v-model="projectBody.address.city"
          />
        </div>
        <div class="input-container">
          <label class="label">Postcode</label>
          <base-input
            type="tel"
            v-model="projectBody.address.postCode"
          />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <base-button
        @click="deleteProject"
        type="danger"
        :loading="deletingProject"
        :disabled="deletingProject || editingProject"
      >Verwijderen</base-button>
      <div class="flex-divider"></div>
      <base-button
        @click="closeModal"
        type="secondary"
      >Annuleren</base-button>
      <base-button
        @click="editProject"
        :loading="editingProject"
        :disabled="editingProject || deletingProject"
      >
        <base-icon
          iconRef="save"
          position="left"
        />Opslaan
      </base-button>
    </div>
  </div>
</template>

<script>
import Firebase from "firebase";

export default {
  name: "project-edit-modal",
  data: function() {
    return {
      deletingProject: false,
      editingProject: false,
      projectBody: {
        projectName: "",
        description: "",
        address: {
          street: "",
          houseNumber: "",
          city: "",
          postCode: ""
        }
      }
    };
  },
  computed: {
    currentProject: function() {
      return this.$store.getters.getCurrentClientPage.project;
    },
    currentClient: function() {
      return this.$store.getters.getClientsList.find(client => {
        return client.id == this.currentProject.data().belongsTo;
      });
    }
  },
  methods: {
    editProject: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.editingProject = true;
          const projectData = {
            id: this.currentProject.id,
            body: this.$editProjectDataObject(this.projectBody)
          };
          Firebase.firestore()
            .collection("projects")
            .doc(projectData.id)
            .update(projectData.body)
            .then(() => {
              Firebase.firestore()
                .collection("projects")
                .doc(projectData.id)
                .get()
                .then(doc => {
                  this.$store.commit("setCurrentClientPageProject", doc);
                  this.editingProject = false;
                  this.closeModal();
                });
            });
        }
      });
    },
    deleteProject: function() {
      this.$dialog.confirm({
        message: `Weet je zeker dat je het project:
        <p class="dialog-attention">${
          this.currentProject.data().projectName
        }</p>
        wilt verwijderen?`,
        cancelText: "Annuleer",
        confirmText: "Verwijder",
        type: "is-danger",
        onConfirm: () => {
          this.deletingProject = true;
          const projectData = {
            id: this.currentProject.id,
            body: this.$deleteProjectDataObject()
          };
          this.$store.dispatch("editProject", projectData).then(() => {
            this.deletingProject = false;
            this.closeModal();
            this.$router.push(`/klant/${this.currentClient.id}`);
          });
        }
      });
    },
    closeModal: function() {
      this.$store.commit("setModalShown", {
        dataType: "project",
        modalType: "edit",
        shown: false
      });
    }
  },
  mounted: function() {
    this.projectBody = Object.assign({}, this.currentProject.data());
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/project-edit-modal.vue